import React from 'react'
import { fromJS } from 'immutable'

class Dialog extends React.Component
{

    constructor(props)
    {
        super(props)
        this.state = {
            dialog: null,
            shown: false
        }

        props.create(this)
    }

    /**
     * {
     *      text: String,
     *      buttons: [ { text: String, onClick: func } ]
     * }
     */
    show(conf)
    {
        this.setState({ config: fromJS(conf), shown: true })
    }

    text(text)
    {
        this.setState({ config: fromJS({
            content: text,
            buttons: [{ text: Messages("app.ok") }]
        }), shown: true })
    }

    dismiss()
    {
        this.setState({ shown: false })
    }

    render()
    {
        const conf = this.state.config

        const text = conf && conf.get("content") ? (
            <div className="dialog-content">{ conf.get("content") }</div>
        ) : null;

        const buttons = conf && conf.get("buttons") && conf.get("buttons").size ? (
            conf.get("buttons").map(b => <div
                key={ b.get("text") } 
                onClick={ () => {
                    this.dismiss()
                    if (b.get("onClick")) {
                        b.get("onClick")()
                    }
                } }
                className="dialog-button">{ b.get("text") }
            </div>)
        ) : null;

        return (
            <div className="dk-dialog-container">
                <div className={ "dk-dialog-shadow " + (this.state.shown ? "" : "hidden") } />
                <div className="dk-window-container">
                    <div className={ "dk-dialog " + (this.state.shown ? "" : "hidden") }>
                        { text }
                        { buttons }
                    </div>
                </div>
            </div>
        )
    }

}

export default Dialog
export { Dialog }